import React, { useRef, useState } from "react";

import ReactToPrint from "react-to-print";

import { Flex, Spinner, Text, Box } from "@chakra-ui/react";

import RelatorioService from "../../../main/services/RelatorioService";
import { FaFilePdf } from "react-icons/fa";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../helpers/Funcionalidades";
import { ComponentToPrintRelatorioServico } from "../ComponentToPrintRelatorioServico";

export const PrintButtonRelatorioServico = ({
  user,
  entidade,
  dados,
  roleKeycloack,
}) => {
  const componentToPrintRef = useRef(null);
  const [dataPendencias, setDataPendencias] = useState([]);
  const [columnsPendencias, setColumnsPendencias] = useState([]);
  const [loading, setLoading] = useState(false);
  const tempObj = JSON.parse(sessionStorage.getItem("table-" + entidade));
  const storage = JSON.parse(sessionStorage.getItem(entidade + "-filter"));

  const beforeGetContent = async () => {
    setLoading(true);
    try {
      const statusMap = {
        A: "ATIVO",
        D: "DESATIVADO",
        S: "SUSPENSO",
      };
      const status = storage?.statusRelatorio.map((item) => statusMap[item]);
      const generos = (storage?.idGenero || [])
        ?.flat()
        ?.map((item) => item.genero)
        ?.filter(Boolean);
      const nomeServicosAcolhimentos = (storage?.idsServicosAcolhimento || [])
        ?.flat()
        ?.map((item) => item.nomeFantasia)
        ?.filter(Boolean);
      const municipiosOrgaos = (storage?.idMunicipioOrgao || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter((id) => id !== "" && id != null);
      const promotoriasOrgaos = (storage?.idPromotoriaOrgaos || [])
        ?.flat()
        ?.map((item) => ({
          id: item.id,
          idMunicipio: item.idMunicipio,
        }))
        ?.filter((id) => id !== "" && id != null);
      const varasOrgaos = (storage?.idVaraOrgaos || [])
        ?.flat()
        ?.map((item) => ({
          id: item.id,
          idMunicipio: item.idMunicipio,
        }))
        ?.filter((id) => id !== "" && id != null);
      const naturezas = (storage?.naturezaServico || [])
        ?.flat()
        ?.map((item) => item?.id?.toUpperCase())
        ?.filter((id) => id !== "" && id != null);
      const regimes = (storage?.regime || [])
        ?.flat()
        ?.map((item) => item.id)
        ?.filter((id) => id !== "" && id != null);
      const modalidades = (storage?.modalidade || [])
        ?.flat()
        ?.map((item) => item.descricao)
        ?.filter(Boolean);

      const SAF =
        Array.isArray(storage?.regime) &&
        storage?.regime?.flat()?.some((item) => item.id === "SAF");

      const idadeMin = [storage?.idadeInicial, storage?.idadeMinima].find(
        (v) => v != null && v !== "" && v !== "null",
      );

      const idadeMax = [storage?.idadeFinal, storage?.idadeMaxima].find(
        (v) => v != null && v !== "" && v !== "null",
      );

      const valuesToSend = {
        status: status,
        localizacaoServicoAcolhimento: {
          estados: storage?.idEstado
            ? storage?.idEstado
                .flat()
                .map((item) => item.id)
                .filter((item) => item.id !== "")
            : [],
          municipios: storage?.idMunicipio
            ? storage?.idMunicipio
                .flat()
                .map((item) => ({
                  id: item.id,
                  idEstado: item.idEstado,
                }))
                .filter((item) => item.id !== "")
            : [],
          bairros: storage?.idBairro
            ? storage?.idBairro
                .flat()
                .map((item) => ({
                  id: item.id,
                  idMunicipio: item.idMunicipio,
                }))
                .filter((item) => item.id !== "")
            : [],
          nomeServicosAcolhimentos: nomeServicosAcolhimentos,
        },
        orgaos: {
          municipios: municipiosOrgaos,
          promotorias: promotoriasOrgaos,
          varasInfancias: varasOrgaos,
        },
        caracterizacaoServicoAcolhimento: {
          regimes: regimes,
          modalidades:
            SAF &&
            !modalidades.includes("Não se aplica") &&
            modalidades?.length > 0
              ? [...modalidades, "Não se aplica"]
              : modalidades,
          naturezas: naturezas,
        },
        perfilAtendimento: {
          ...(storage?.radioGenero && {
            tipoGenero:
              storage.radioGenero === "AS"
                ? "ATENDE"
                : storage.radioGenero === "SR"
                  ? "SEM_RESTRICAO"
                  : storage.radioGenero === "NA"
                    ? "NAO_ATENDE"
                    : "",
          }),

          generos: generos.length > 0 ? generos : [],

          ...(storage?.radioFaixaEtaria && {
            restricao:
              storage.radioFaixaEtaria === "TO"
                ? "TODOS"
                : storage.radioFaixaEtaria === "AT"
                  ? "ATENDE"
                  : storage.radioFaixaEtaria === "CR"
                    ? "COM_RESTRICAO"
                    : "",
          }),

          ...(idadeMin && {
            idadeMinima: Number(idadeMin),
          }),

          ...(idadeMax && {
            idadeMaxima: Number(idadeMax),
          }),

          restricaoDeficiencia:
            storage?.radioSaudeCriancaDeficiencia?.length > 0
              ? storage?.radioSaudeCriancaDeficiencia
              : [],

          restricaoSubstancias:
            storage?.radioSaudeSubstanciasPsicoativas?.length > 0
              ? storage?.radioSaudeSubstanciasPsicoativas
              : [],

          restricaoCuidados:
            storage?.radioSaudeCriancaCuidados?.length > 0
              ? storage?.radioSaudeCriancaCuidados
              : [],
        },

        regularidade: {
          registroCMDCA: storage?.registroCMDCA ? storage?.registroCMDCA : [],
          registroValidoCMDCA: storage?.registroValidoCMDCA
            ? storage?.registroValidoCMDCA
            : [],
          inscricaoCMDCA: storage?.inscricaoCMDCA
            ? storage?.inscricaoCMDCA
            : [],
          inscricaoValidaCMDCA: storage?.inscricaoValidaCMDCA
            ? storage?.inscricaoValidaCMDCA
            : [],
          inscricaoCMAS: storage?.inscricaoCMAS ? storage?.inscricaoCMAS : [],
          inscricaoValidaCMAS: storage?.inscricaoValidaCMAS
            ? storage?.inscricaoValidaCMAS
            : [],
        },

        planejamento: {
          possuiPlanoTrabalho: storage?.possuiPlano ? storage?.possuiPlano : [],
          possuiProjetoPoliticoPedagogico: storage?.possuiProjeto
            ? storage?.possuiProjeto
            : [],
          possuiRelatorioAnual: storage?.possuiRelatorio
            ? storage?.possuiRelatorio
            : [],
          possuiRegimentoInterno: storage?.possuiRegimento
            ? storage?.possuiRegimento
            : [],
        },

        possuiAcessoMCA: storage?.possuiAcessoMCA
          ? storage?.possuiAcessoMCA
          : [],
        possuiVoluntariado: storage?.possuiVoluntariado
          ? storage?.possuiVoluntariado
          : [],

        apadrinhamento: {
          mantemProgramaApadrinhamento: storage?.mantemPrograma
            ? storage?.mantemPrograma
            : [],
          inscritoCMDCA: storage?.encontraInscritoCMDCA
            ? storage?.encontraInscritoCMDCA
            : [],
        },

        ...((storage?.possuiVaga === "S" || storage?.possuiVaga === "N") && {
          vagasDisponiveis: storage?.possuiVaga === "S",
        }),
        pageSize: 9999999,
        page: 0,
        sortField: tempObj ? tempObj[0]?.id : "nomeCrianca",
        sortType: tempObj ? (tempObj[0]?.desc ? "DESC" : "ASC") : "ASC",
      };

      const res =
        await RelatorioService.getRelatorioServicoAcolhimento(valuesToSend);

      if (res?.data) {
        setColumnsPendencias([
          {
            Header: "Serviço de Acolhimento Atual",
            accessor: "servicoAcolhimentoNomeFantasia",

            Cell: (props) => {
              const permissaoServico =
                roleKeycloack.includes(criancaFunc.visualizarTudo) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarPartePPCAAM,
                ) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarParteMP,
                ) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarParteTJ,
                ) ||
                ((roleKeycloack.includes(
                  criancaFunc.visualizarTudoAcolhimento,
                ) ||
                  roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
                  user?.orgaoExterno?.includes(
                    props?.row?.original?.idPessoaJuridica,
                  ));
              const temRiscoVida =
                props?.row?.original?.riscoVida === "S" ? true : false;

              if (temRiscoVida && !permissaoServico) {
                return <span></span>;
              } else {
                const idServico = props?.row?.original?.id;
                if (!idServico) {
                  return <span></span>;
                } else {
                  return (
                    <>
                      {roleKeycloack &&
                      roleKeycloack.includes(
                        servicoAcolhimentoFunc.visualizar,
                      ) ? (
                        <Box wordBreak={"break-word"} title={props?.value}>
                          <Text> {props?.value}</Text>
                        </Box>
                      ) : (
                        <Text>{props?.value}</Text>
                      )}
                    </>
                  );
                }
              }
            },
          },
          {
            Header: "Status",
            accessor: "status",
            Cell: (props) => {
              return <span>{props.value}</span>;
            },
          },
          {
            Header: "Telefone",
            accessor: "telefone",

            Cell: (props) => {
              return <Text>{props.value}</Text>;
            },
          },

          {
            Header: "Endereço",
            accessor: "endereco",
            Cell: (props) => {
              return <Text minWidth="300px">{props.value}</Text>;
            },
          },
          {
            Header: "Vagas Disponíveis",
            accessor: "vagasDisponiveis",
            Cell: (props) => {
              return <Text>{props.value ?? ""}</Text>;
            },
          },
        ]);
      }

      setDataPendencias(res?.data?.content);

      setLoading(false);
    } catch (erro) {
      console.log("Erro ao acessar os dados de impressao");
      console.log(erro);
      setLoading(false);
    }
  };

  const customPageStyle = `
    @page {
      margin: 0mm;
      size: auto;  
      margin-top: 0mm; 
      margin-bottom: 12mm; 
    } 
    @media print { 
      body { 
        -webkit-print-color-adjust: exact; 
      } 
    }
  `;

  return (
    <>
      <ReactToPrint
        onBeforeGetContent={beforeGetContent}
        onAfterPrint={() => setLoading(false)}
        pageStyle={customPageStyle}
        documentTitle={`MCA - Relatório de Serviço de Acolhimento`}
        trigger={() => {
          return loading ? (
            <Spinner size="sm" />
          ) : (
            <Flex
              alignItems="center"
              gap={2}
              cursor="pointer"
              onClick={() => alert("imprimir PDF")}
            >
              <Flex bg="red" rounded="full" p={1}>
                <FaFilePdf color="white" />
              </Flex>

              <Text as="b" color="red" fontSize={"md"}>
                Exportar em PDF
              </Text>
            </Flex>
          );
        }}
        content={() => componentToPrintRef.current}
      />
      <div style={{ display: "none" }}>
        <ComponentToPrintRelatorioServico
          ref={componentToPrintRef}
          dataPendencias={dataPendencias ? dataPendencias : null}
          columnsPendencias={columnsPendencias}
          roleKeycloack={roleKeycloack}
          dados={dados}
          user={user}
          storage={storage}
        />
      </div>
    </>
  );
};
